import "./wdyr";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.scss";
import { GlobalToast } from "@microbeta/ui";
import { ContextProviders } from "./context/ContextProviders.tsx";

// Handle dynamic import (chunk) load failures gracefully by reloading the page.
// This handles cases where a new version has been deployed and the old chunks
// are no longer available in the bucket.
window.addEventListener("vite:preloadError", (event) => {
  console.warn("Vite preload error detected, reloading page...", event);
  window.location.reload();
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <ContextProviders>
      <App />
      <GlobalToast />
    </ContextProviders>
  </StrictMode>
);
